import { MarketClient } from "./market";

export default function Page() {
  return <MarketClient />;
}
